<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <el-form size="mini" :model="form" ref="catInfoForm" class="components">
        <el-row>
          <el-col>
            <el-col :span="6">
              <el-form-item label="의뢰번호" prop="catNm">
                <el-input v-model="form.requestId" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="의뢰일자">
                <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestDt" style="width: 100%;" value-format="yyyy-MM-dd" disabled></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="의뢰자" prop="catNm">
                <el-input v-model="form.requestNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="의뢰구분">
                <el-input v-model="form.maType" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="대상모델">
              <el-input v-model="form.modelNm" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="수량" prop="catNm">
              <el-input v-model="form.modelQty" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="요청일자">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestProcDt" style="width: 100%;" value-format="yyyy-MM-dd" disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="처리기사">
              <el-select v-model="form.userId">
                <el-option
                    v-for="item in combos['userId']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-col :span="4">
            <el-form-item label="사이트명">
                <el-input v-model="form.siteTypeNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="주소">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="8">
                      <el-input type="text" v-model="form.addr1" disabled></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.addr2" disabled></el-input>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-col :span="8">
              <el-form-item label="고객명">
                <el-input v-model="form.chargeNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="전화번호">
                <el-input v-model="form.telNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="휴대폰">
                <el-input v-model="form.hpNo" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>

        <el-row class="demo-autocomplete" >
          <el-col :span="24">
            <el-form-item label="작업내용">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  placeholder="작업내용을 작성하세요."
                  v-model="form.workDetails">
              </el-input>
            </el-form-item>
            <div class="grid-content bg-purple"></div>
          </el-col>
        </el-row>

        <el-row class="demo-autocomplete" >
          <el-col :span="24">
            <el-form-item label="특이사항">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  placeholder="특이사항을 작성하세요."
                  v-model="form.memo">
              </el-input>
            </el-form-item>
            <div class="grid-content bg-purple"></div>
          </el-col>
        </el-row>

      </el-form>

      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="table-name">
              <h3 class="ico_table_name">{{ `사용/회수자재` }}</h3>
            </div>
            <div class="btn-wrap btn-type1 clearfix" style="float: right; margin-bottom: 0px;">
              <button class="btn-size btn-gray fl_left" @click="openModel">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                추가
              </button>
              <button class="btn-size btn-gray fl_left" @click="deleteItem" v-if="form.requestId != ''">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                삭제
              </button>
            </div>
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  row-selection="single"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="mainData"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  @cell-value-changed="onCellValueChanged"
                  @grid-ready="onReadyMain"/>
            </div>
          </div>
        </div>
      </div>


      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="table-name">
              <h3 class="ico_table_name">{{ `처리내역` }}</h3>
            </div>
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="gridSub"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  row-selection="single"
                  :context="context"
                  :column-defs="columnSubDefs"
                  :grid-options="subGridOptions"
                  :row-data="subData"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  @grid-ready="onReadySub"/>
            </div>
          </div>
        </div>
      </div>

      <div class="table-b">
        <div class="table-name">
<!--          <h3 class="ico_table_name">{{ `처리내역` }}</h3>-->
        </div>
        <el-form size="mini" :model="form" ref="catInfoForm" class="components">
          <el-row class="demo-autocomplete" >
            <el-col :span="10">
              <el-form-item label="처리내역">
                <el-radio-group v-model="form.procType">
                  <el-radio
                      v-for="item in combos['procType']"
                      :key="item.key"
                      :label="item.key"
                      :value="item.key">{{ item.value }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  placeholder=" 상세처리내역을 작성하세요."
                  v-model="form.setupResult">
              </el-input>
              <div class="grid-content bg-purple"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="1">
              <el-button type="info" icon="el-icon-document" @click="chkSave">
                선택저장
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="table-b">
        <div class="table-name">
          <h3 class="ico_table_name">{{ `대행료` }}</h3>
        </div>
        <el-form size="mini" :model="form" ref="catInfoForm" class="components">

          <el-row>
            <el-col>
              <el-col :span="6">
                <el-form-item label="처리비">
                  <el-input v-model="form.procUnitPrice1" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="원거리수당">
                  <el-input v-model="form.procEtcPrice1" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="기타비용" prop="catNm">
                  <el-input v-model="form.procEtcPrice2" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="합계" prop="catNm">
                  <el-input v-model="form.procAmt" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div class="table-b">
        <div class="table-name">
          <h3 class="ico_table_name">{{ `기타설치결과` }}</h3>
        </div>
        <el-form size="mini" :model="form" ref="catInfoForm" class="components">
          <el-row class="demo-autocomplete" >
            <el-col :span="24">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  placeholder="설치결과를 작성하세요."
                  v-model="form.procResult">
              </el-input>
              <div class="grid-content bg-purple"></div>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="table-b">
        <div class="table-name">
          <h3 class="ico_table_name">{{ `정산비용` }}</h3>
        </div>
        <el-form size="mini" :model="form" ref="catInfoForm" class="components">
          <el-row>
            <el-col>
              <el-col :span="12">
                <el-form-item label="처리비">
                  <el-input v-model="form.squareProcUnitPrice1" :disabled="disabledSquareProcUnitPrice1" @input="squareProcCalcAmt"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="원거리수당">
                  <el-input v-model="form.squareProcEtcPrice1" :disabled="disabledSquareProcEtcPrice1" @input="squareProcCalcAmt"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-col :span="12">
                <el-form-item label="기타비용" prop="catNm">
                  <el-input v-model="form.squareProcEtcPrice2" :disabled="disabledSquareProcEtcPrice2"  @input="squareProcCalcAmt"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="합계" prop="catNm">
                  <el-input v-model="form.squareProcAmt" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-col :span="12">
                <el-form-item label="정산년월" prop="catNm">
                  <el-date-picker type="month" placeholder="Pick a date" v-model="form.squareYymm" style="width: 100%;" value-format="yyyyMM" :disabled="disabledSquareYymm"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="table-a">
        <el-row :gutter="6">
          <el-col>
            <el-button type="info" icon="el-icon-document" v-show="showButton" @click="modify">
              진행중
            </el-button>
            <el-button type="info" icon="el-icon-document" v-show="showButton" @click="success">
              처리완료
            </el-button>
            <el-button type="primary" icon="el-icon-folder-checked" v-show="showBtnApproval" @click="buttonClickEventAction('APPROVAL')">
              승인
            </el-button>
            <el-button type="danger" icon="el-icon-folder-checked" v-show="showBtnApprovalCancel" @click="buttonClickEventAction('APPROVALCANCEL')">
              승인취소
            </el-button>
            <el-button type="info" icon="el-icon-document" v-show="showBtnSquareCancel" @click="buttonClickEventAction('SQUARECANCEL')">
              정산취소
            </el-button>
            <el-button type="info" icon="el-icon-document" v-show="showBtnSquare" @click="buttonClickEventAction('SQUARE')">
              정산
            </el-button>
          </el-col>
        </el-row>
      </div>

    </div>
  </layout>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import SelectCellRendererSecondary from "@/components/agGrid/select-cell-renderer-secondary";
import mixin from "@/mixin/lucoms";
import SiteSelectModal from "@/components/LucomsModal/SiteSelectModal";
import AgGridSearchBtn from "@/components/agGrid/AgGridSearchBtn";
import Layout from '@/components/Slot/ModalSlot.vue';
import _ from "lodash";
import UseMateSelectModal from "@/components/LucomsModal/UseMateSelectModal";
import ReqMateEnterModal from "@/components/LucomsModal/ReqMateEnterModal";

function comma(val){
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default {
  name: "bsMaEditInfo",
  mixins: [mixin],
  props: {
    data: {
      Type: Array
      , required: false
    },
  },
  components: {Layout},
  data() {
    return {
      // data: [],
      title: 'BS/MA내역',
      delData: [],
      mainData: [],
      subData: [],
      mainRowIndex: "",
      gridStyle : 'padding-top: 40px; width: 100%;height: 200px; min-height:100px;',
      columnDefs: [],
      columnSubDefs: [],
      mainGridApi : null,
      mainColumnApi : null,
      subGridApi : null,
      subColumnApi : null,
      context: {
        headerAllCheckEvent: this.allChk
      },
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        getRowId: (params) => params.data.id,
      },
      subGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      defaultColDef: {
        resizable: true
        , filter:false
        , sortable: true
      },
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkboxRenderer: CheckboxCellRenderer,
        schBtn : AgGridSearchBtn,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer,
        secondarySelect: SelectCellRendererSecondary,
      },
      form: {
        companyId : '',
        requestId : '',          // 의뢰번호
        requestDt : '',          // 의뢰일자
        requestNm : '',          // 의뢰자
        maType : '',             // 의뢰구분
        siteType : '',           // 고객구분
        siteTypeNm : '',         // 고객구분
        addr1 : '',              // 주소1
        addr2 : '',              // 주소2
        chargeNm : '',           // 고객명
        telNo : '',              // 전화번호
        hpNo : '',               // 휴대폰
        modelNm : '',            // 모델명
        modelQty : '',           // 의뢰대수
        procType : '',           // 처리내역
        requestProcDt : '',      // 처리요청일
        workDetails : '',        // 작업내용
        memo : '',               // 특기사항
        squareYymm : '',
        procUnitPrice1 : '',     // 처리비
        procUnitPrice2 : '',     // 단가
        procEtcPrice1 : '',      // 출장급지
        procEtcPrice2 : '',      // 기타비용
        catId : '',              // 지역
        asAgentId: '',            // 지역상세
        sortType : '',           // 승인/정산처리유형
        siteId : '',             // 사이트Id
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        userId : '',             // 처리기사
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelGroup: '',          /** 모델그룹 */
        standardModelNm: '',     /** 표준모델 */
        //modelNm: '',           /** 모델명 */
        modelId: '',             /** 모델ID */
        siteTypeCombo : '',
        procResult : '',
        applyItemGoodQty : '',
        recallItemQty : '',
        procYn : '', // 설치 완료 여부
        confirmYn : '', // 승인 완료 여부
        squareYn : '', // 정산 완료 여부
        type : '',
        squareProcUnitPrice1: '', // 정산처리 - 처리비
        squareProcEtcPrice1: '',  // 정산처리 - 원거리수당
        squareProcEtcPrice2: ''   // 정산처리 - 기타비용
      },
      defForm: {
        companyId : '',
        requestId : '',          // 의뢰번호
        requestDt : '',          // 의뢰일자
        requestNm : '',          // 의뢰자
        maType : '',             // 의뢰구분
        siteType : '',           // 고객구분
        siteTypeNm : '',         // 고객구분
        addr1 : '',              // 주소1
        addr2 : '',              // 주소2
        chargeNm : '',           // 고객명
        telNo : '',              // 전화번호
        hpNo : '',               // 휴대폰
        modelNm : '',            // 모델명
        modelQty : '',           // 의뢰대수
        procType : '',           // 처리내역
        requestProcDt : '',      // 처리요청일
        workDetails : '',        // 작업내용
        memo : '',               // 특기사항
        procUnitPrice1 : '',     // 처리비
        procUnitPrice2 : '',     // 단가
        procEtcPrice1 : '',      // 출장급지
        procEtcPrice2 : '',      // 기타비용
        catId : '',              // 지역
        asAgentId: '',            // 지역상세
        sortType : '',           // 승인/정산처리유형
        siteId : '',             // 사이트Id
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        userId : '',             // 처리기사
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelGroup: '',          /** 모델그룹 */
        standardModelNm: '',     /** 표준모델 */
        //modelNm: '',           /** 모델명 */
        modelId: '',             /** 모델ID */
        siteTypeCombo : '',
        procResult : '',
        applyItemGoodQty : '',
        recallItemQty : '',
      },
      // eslint-disable-next-line vue/no-dupe-keys
      tapName: "default",
      combos: {
        'maType' : [],
        'catId' : [],
        'asAgentId' : [],
        'procType' : [],
        'userId' : [],
        'agentUser' : [],
      },

      showButton : false,                      /** 버튼 표시 여부 **/
      showBtnModify : false,                   /** 진행중 버튼 표시 여부 **/
      showBtnSuccess : false,                  /** 설치완료 버튼 표시 여부 **/
      showBtnApproval : true,                  /** 승인 버튼 표시 여부 **/
      showBtnApprovalCancel : true,            /** 승인취소 버튼 표시 여부 **/
      showBtnSquareCancel  : true,             /** 정산취소 버튼 표시 여부 **/
      showBtnSquare : true,                    /** 정산 버튼 표시 여부 **/
      disabledSquareYymm : false,              /** 정산년월 disabled 여부 **/
      disabledSquareProcUnitPrice1 : false,    /** 정산비용 처리비 disabled 여부 **/
      disabledSquareProcEtcPrice1 : false,     /** 정산비용 원거치출장비 disabled 여부 **/
      disabledSquareProcEtcPrice2 : false,     /** 정산비용 기타비용 disabled 여부 **/
      disabledSquareProcAmt : false,          /** 정산비용 합계 disabled 여부 **/
    };
  },
  methods: {
    setBsMaEditInfo() {

      this.subData = this.data.uvwBsMaItemI;
      this.mainData = this.data.uvwBsMaItemD;
      Object.assign(this.form, this.data.uvwBsMaItemM[0]);

      // 처리기사, 지역센터 값 세팅
      this.getAgentId(this.form.asAgentId);
      this.changeData();

      if(this.form.procYn == 'N' && this.form.confirmYn == 'N' && this.form.squareYn == 'N'){
        this.showButton = true;
      }

      // 승인
      if(this.form.procYn == 'N' || this.form.confirmYn == 'Y' || this.form.squareYn == 'Y' || this.form.type != "Approval") this.showBtnApproval = false;
      // 승인취소
      if(this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'Y'|| this.form.type != "Approval") this.showBtnApprovalCancel = false;

      //todo 정산은 asIs에서 보이지 않음. 주석처리 함. 정산 권한 확인 필요 시작
      // // 정산
      if(this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'Y' ||  this.form.type != "Square") this.showBtnSquare = false;
      // 정산취소
      if(this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'N' ||  this.form.type != "Square") this.showBtnSquareCancel = false;

      if(this.form.procYn == 'N' && this.form.confirmYn == 'Y' && this.form.squareYn == 'Y'){
        this.disabledSquareProcUnitPrice1 = true;
        this.disabledSquareProcEtcPrice1 = true;
        this.disabledSquareProcEtcPrice2 = true;
        //this.disabledSquareSetupAmt = true;
      }
      // //정산년월
       if(this.form.procYn == 'N' && this.form.confirmYn == 'N' && this.form.squareYn == 'Y') this.disabledSquareYymm = true;
      // 정산전까지는 콜센타가 아닌(센터)는 안보이도록 - AS-IS 그대로 구현.
      // if(this.auth[0].grantExtend1 === 'N' && (this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'N')){
      //   this.showForm = false;
      // }
      //todo 정산은 asIs에서 보이지 않음. 주석처리 함. 정산 권한 확인 필요 종료
    },
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.mainGridApi.getRowNodeId = data => {
        return data.bsMaItemId;
      };

      //this.getGuaranteeMonth();
      this.init();
    },
    onReadySub() {
      this.subGridApi = this.subGridOptions.api;
      this.subColumnApi = this.subGridOptions.columnApi;

    },
    async init() {
      // this.form.requestDt = this.$moment().format('YYYY-MM-DD') /** 당일 */
      // this.form.requestProcDt = this.$moment().format('YYYY-MM-DD') /** 당일 */
      this.$store.commit('loading');
      await this.$http.post(`/api/agent/InstallAgnet/init`)
          .then(response => {
            this.combos['setupStatus'] = response.data.setupStatus;
            this.combos['agentUser'] = response.data.agentUser;
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },

    //사용 / 회수 자재
    createMainColumnDefs() {
      const vm = this;
      this.columnDefs = [
        {
          headerName:'선택',
          field:'regYn',
          width:80,
          cellStyle:{textAlign: 'center'},
          cellRenderer: 'checkboxRenderer',
          ellRendererParams: {
            trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
            , disable: true
          },
        },
        {
          headerName:'No',
          field:'순위',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'사용품번', field:'itemCd', width:200},
        {headerName:'사용품명', field:'itemNm', width:350},
        {headerName:'사용수량', field:'itemGoodQty', width:120, cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'}, editable : true,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }
        },
        {headerName:'회수', field:'', width:100,
          cellRenderer: 'schBtn',
          cellRendererParams(params) {
            return {
              funcNm: 'updateRealItem',
              onModal: 'Y',
              val: (params.rowIndex)
            }
          }
        },
        {headerName:'회수품번', field:'recallItemCd', width:200},
        {headerName:'회수품명', field:'recallItemNm', width:350},
        {headerName:'회수수량', field:'recallItemQty', width:120, cellStyle:{textAlign: 'right'}, editable : false,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }
        },
      ];

      // 처리내역
      this.columnSubDefs = [
        {
          headerName: '선택'
          , field:'chk'
          , width : 80
          , editable: false
          ,headerComponent: 'checkboxRenderer',
          headerComponentParams: (params) => {
            return params;
          }
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName:'No',
          field:'순위',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'제조번호', field:'serialNo', width:250, editable : true },
        {headerName:'처리내역', field:'procType', width:150, cellStyle:{textAlign: 'center'},
          // valueFormatter: (params) => {
          //   return vm.typeSwitch(params.value);
          // }
          editable: true,
          //headerClass: 'require-column' , //필수입력 컬럼 css
          cellRenderer: 'select',
          cellRendererParams: {
            options: vm.combos['procType'],
            detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
            detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
          },
        },
        {headerName:'상세처리내역', field:'procDetail', width:400, editable : true, cellStyle:{textAlign: 'left'}},
      ];

    },
    openModel() {
      let vm = this;
      this.$modal.open({
        width: 1500,
        component: UseMateSelectModal,
        parent: this,
        props: {
          data: {
            modelNm : vm.form.modelNm
          }
        },
        events: {
          close(param) {

            let allItemIds = '' // 기존의 품목ID들
            if(vm.mainData != '') {
              vm.mainData.map(x => {
                allItemIds += x.itemCd + ','
                return x
              })
            }

            //이미 추가한 품목은 제외시킴
            let vvRetData2 = (allItemIds === '') ? param : ( param.filter(x=>allItemIds.indexOf(x.itemCd + ',') == -1) )
            const vData = vvRetData2

            // const vSumArr = vm.mainData.concat(vData)
            // vm.mainData = vSumArr
            vm.mainData.push(vData.map((x=> {
              x.goodQty = 1
              x.invtYn = ''
              x.itemCd = x.itemCd
              x.itemNm = x.itemNm
              x.itemGoodQty = x.goodQty
              x.recallItemCd = x.itemCd
              x.recallItemNm = x.itemNm
              x.recallItemQty = x.goodQty
              x.recallItemId = x.itemId
              x.productType = "Item"
              x.itemRecycleQty = 0
            })));

            const grid = vm.$refs.grid

            grid.rowData.forEach((x,i)=>{
              vm.mainGridRefresh(i);
            })

            vm.$forceUpdate();

          },
        }
      });
    },
    cancle(){
      // this.form = _.clone(this.defForm);
      this.data = [];
    },
    allChk(){

      const grid = this.$refs.gridSub
      const chkDatas = grid.rowData.filter((x,i) => {
        return x.chk === "Y"
      })

      if(chkDatas.length === this.subData.length){
        this.subGridApi.forEachNodeAfterFilter((v, i) => {
          v.data.chk = "N"
        })
      }else{
        this.subGridApi.forEachNodeAfterFilter((v, i) => {
          v.data.chk = "Y"
        })
      }

      // this.$forceUpdate()
      // this.forceRerender();
      grid.rowData.forEach((x,i)=>{
        this.subGridRefresh(i);
      })

    },
    deleteItem() {

      var list = this.mainData.filter(v => v.regYn === 'Y')

      if(list.length == 0){
        this.$swal({ type: 'warning', text: '삭제할 자재를 선택해 주십시요.'});
        return false;
      }

      const vm = this
      const vData = vm.mainData.filter(v => v.regYn !== 'Y')
      this.delData = vm.mainData.filter(v => v.regYn === 'Y')

      vm.mainData = JSON.parse(JSON.stringify(vData))

    },
    chkSave(){

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.chk === "Y"
      })

      if(chkDatas.length == 0){
        this.$swal({ type: 'warning', text: '체크 박스를 선택해 주십시요.'});
        return false;
      }

      this.$swal({
        type: 'info',
        text: `저장 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {

          chkDatas.forEach((x,i)=>{
            x.procType = this.form.procType;
            x.procDetail = this.form.setupResult;
          });

          grid.rowData.forEach((x,i)=>{
            this.subGridRefresh(i);
          });

        }
      }).finally(() => {
        this.$swal({ type: 'success', text: '저장되었습니다.' });
      });
    },
    closeModal() {
      this.$parent.close();
    },
    mainGridRefresh(idx) {
      var rows = [];
      var rowNode = this.mainGridApi.getDisplayedRowAtIndex(idx);
      rows.push(rowNode);
      this.mainGridApi.redrawRows({ rowNodes: rows });
    },
    subGridRefresh(idx) {
      var rows = [];
      var rowNode = this.subGridApi.getDisplayedRowAtIndex(idx);
      rows.push(rowNode);
      this.subGridApi.redrawRows({ rowNodes: rows });
    },
    typeSwitch(type){
      switch (type){
        case 'Install':
          return type ='설치';
        case 'Check':
          return type ='점검';
        case 'Setting':
          return type ='조정';
        case 'Change':
          return type ='교체';
      }
    },
    getCombo() {
      this.getMaType();
      this.getCatIdCombo();
      this.getProcType();
    },
    getMaType(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 226} })
          .then(response => {
            this.combos['maType'] = response.data || []
          });
    },
    getProcType(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 247} })
          .then(response => {
            this.combos['procType'] = response.data || []
          });
    },
    getCatIdCombo(){
      this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
          .then(response => {
            this.combos['catId'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.asAgentId = null;
      this.form.userId = null;
      // 지역 상세
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: param} })
          .then(response => {
            this.combos['asAgentId'] = response.data || []
          }).finally(() => {
      });
    },
    getSubCatIdChange(param){
      this.$store.commit('loading')
      this.form.userId = null;


      this.$http.post("/api/asAgentMng/detail/agent", {
        companyId: this.$store.state.loginInfo.compCd,
        asAgentId: parseInt(param),
        userId : 0,
        useYn : 'Y',
        processTime: ""
      }).then(response => {
        response.data.map(x => {
          x.key = x.userId
          x.value = x.userNm
          return x
        })
        this.combos['userId'] = response.data

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    // 그리드 데이터 선택 후 처리기사 값 세팅
    getAgentId(param){
      //this.form.userId = '';
      this.$http.post("/api/asAgentMng/detail/agent", {
        companyId: this.$store.state.loginInfo.compCd,
        asAgentId: param,
        userId : 0,
        useYn : 'Y',
        processTime: ""
      }).then(response => {
        this.combos['userId'] = response.data.map(x => {
          x.key = parseInt(x.userId)
          x.value = x.userNm
          return x
        });
        // 그리드에서 선택한 배송기사 값
        let asAgentUserId = (this.form.userId !== undefined) ? this.form.userId.toString() : ''
        if(asAgentUserId !== ''){
          let valueUserId = this.combos['userId'].filter(x => parseInt(x.key) === parseInt(asAgentUserId))[0].key;
          this.form.userId = _.cloneDeep(valueUserId);
        }

      }).finally(() => {
        this.setCatIdAndSubCatId(param);
      })
    },
    modify(){
      const vm = this;

      if(this.form.procYn === 'Y'){
        this.$swal({ type: 'error', text: '설치완료된 설치건 입니다.' });
        return false;
      }

      if(this.form.confirmYn === 'Y'){
        this.$swal({ type: 'error', text: '승인완료된 설치건 입니다.' });
        return false;
      }

      if(this.form.squareYn === 'Y'){
        this.$swal({ type: 'error', text: '정산완료된 설치건 입니다.' });
        return false;
      }


      this.$swal({
        type: 'info',
        text: `수정 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {


          let itemData = this.$refs.grid.rowData;
          let itemSubmitList = [];

          let detailData = this.$refs.gridSub.rowData;
          let detailSubmitList = [];

          //사용/회수 자재
          itemData.forEach(x=>{
            itemSubmitList.push({
              productType    : x.productType,
              itemId         : x.itemId,
              itemGoodQty    : x.itemGoodQty,
              itemRecycleQty : x.itemRecycleQty,
              recallItemId   : x.recallItemId,
              recallItemQty  : x.recallItemQty,
              invtYn         : x.invtYn,
              bsMaItemId     : x.bsMaItemId
            });
          });

          //처리내역
          detailData.forEach(x=>{
            detailSubmitList.push({
              bsMaDetailId   : x.bsMaDetailId,
              serialNo       : x.serialNo,
              procType       : x.procType,
              procDetail     : x.procDetail
            });
          });

          this.$store.commit('loading')
          this.$http.post("/api/agent/bsMaAgent/procBsMa/save", {
            requestId          : this.form.requestId,
            procYn             : 'N',
            procResult         : this.form.procResult,
            userId             : this.form.userId,
            bsMaDeleteItemList : this.delData,
            bsMaItemList       : itemSubmitList,
            bsMaDetailList     : detailSubmitList
          }).then(response => {
            this.$swal({ type: 'success', text: '수정 되었습니다.' });
            this.closeModal();
            // vm.$parent.goOpen();
          }).finally(() => {
            this.$store.commit('finish')
            // this.$swal({ type: 'success', text: '저장되었습니다.' });
            // vm.closeModal();
          });
        }
      }).catch(() =>{
        this.$swal({ type: 'error', text: '오류가 발생 했습니다.' });
      }).finally(() => {
      });
    },
    success(){
      const vm = this;

      if(this.form.procYn === 'Y'){
        this.$swal({ type: 'error', text: '설치완료된 설치건 입니다.' });
        return false;
      }

      if(this.form.confirmYn === 'Y'){
        this.$swal({ type: 'error', text: '승인완료된 설치건 입니다.' });
        return false;
      }

      if(this.form.squareYn === 'Y'){
        this.$swal({ type: 'error', text: '정산완료된 설치건 입니다.' });
        return false;
      }

      let chk = 0;

      this.subData.forEach(x=>{
        if(x.serialNo == '') chk +=1;
      })

      if(chk > 0){
        this.$swal({ type: 'error', text: '처리완료 하시려면 모델의 제조번호를 반드시 입력하셔야 합니다.' });
        console.log('chk  ',chk);
        return false;
      }

      this.$swal({
        type: 'info',
        text: `설치완료 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {


          let itemData = this.$refs.grid.rowData;
          let itemSubmitList = [];

          let detailData = this.$refs.gridSub.rowData;
          let detailSubmitList = [];

          itemData.forEach(x=>{
            itemSubmitList.push({
              requestId      : x.requestId,
              productType    : x.productType,
              itemId         : x.itemId,
              itemGoodQty    : x.itemGoodQty,
              itemRecycleQty : x.itemRecycleQty,
              recallItemId   : x.recallItemId,
              recallItemQty  : x.recallItemQty,
              invtYn         : x.invtYn,
              bsMaItemId     : x.bsMaItemId
            });
          });

          detailData.forEach(x=>{
            detailSubmitList.push({
              requestId      : x.requestId,
              bsMaDetailId   : x.bsMaDetailId,
              serialNo       : x.serialNo,
              procType       : x.procType,
              procDetail     : x.procDetail
            });
          });

          this.$store.commit('loading')
          this.$http.post("/api/agent/bsMaAgent/procBsMa/save", {
            requestId          : this.form.requestId,
            procYn             : 'Y',
            procResult         : this.form.procResult,
            userId             : this.form.userId,
            bsMaDeleteItemList : this.delData,
            bsMaItemList       : itemSubmitList,
            bsMaDetailList     : detailSubmitList
          }).then(response => {
            this.$swal({ type: 'success', text: '설치완료 되었습니다.' });
            this.closeModal();
            vm.$parent.goOpen();
          }).finally(() => {
            this.$store.commit('finish')
            this.$swal({ type: 'success', text: '저장되었습니다.' });
            vm.closeModal();
          });
        }
      }).catch(() =>{
        this.$swal({ type: 'error', text: '오류가 발생 했습니다.' });
      }).finally(() => {
      });

    },
    //  그리드 데이터 선택 후 지역/센터 값 세팅
    setCatIdAndSubCatId(param){
      let valueSubCatId;
      this.$http.get(`/api/codeMng/detail`, { params: {catKey: param}})
          .then(response => {
            // 조회 한 지역/센터 값
            valueSubCatId = response.data;
            // 지역 값 선택
            this.form.catId  = _.cloneDeep(this.combos['catId'].filter(x => parseInt(x.key) === valueSubCatId[0].parentId)[0].key)
            // 지역 상세값 리스트 조회
            this.$http.get(`/api/codeMng/combo`, { params: {parentId: valueSubCatId[0].parentId} }).then(response => {
              this.combos['asAgentId'] = response.data || []
              // 지역 상세값 선택
              this.form.asAgentId  = _.cloneDeep(this.combos['asAgentId'].filter(x => x.key === valueSubCatId[0].catKey)[0].key)
            })
          })
    },
    dataClear(){
      this.form.companyId = ''
      this.form.requestId = ''          // 의뢰번호
      this.form.requestDt = ''          // 의뢰일자
      this.form.requestNm = ''          // 의뢰자
      this.form.maType = ''             // 의뢰구분
      this.form.siteType = ''           // 고객구분
      this.form.siteTypeNm = ''         // 고객구분명
      this.form.addr1 = ''              // 주소1
      this.form.addr2 = ''              // 주소2
      this.form.chargeNm = ''           // 고객명
      this.form.telNo = ''              // 전화번호
      this.form.hpNo = ''               // 휴대폰
      this.form.modelNm = ''            // 모델
      this.form.modelQty = ''           // 의뢰대수
      this.form.requestProcDt = ''      // 처리요청일
      this.form.workDetails = ''        // 작업내용
      this.form.memo = ''               // 특기사항
      this.form.procUnitPrice1 = ''     // 처리비
      this.form.procUnitPrice2 = ''     // 단가
      this.form.procEtcPrice1 = ''      // 출장급지
      this.form.procEtcPrice2 = ''      // 기타비용
      this.form.catId = ''              // 지역
      this.form.asAgentId = ''          // 지역상세
      this.form.sortType = ''           // 승인/정산처리유형
      this.form.siteNm1 = ''            // 사이트명1
      this.form.siteNm2 = ''            // 사이트명2
      this.form.siteNm3 = ''            // 사이트명3
      this.form.userId = ''             // 처리기사
      this.data = '';
    },
    searchSite(){
      /** 사이트선택(고객구분) */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: SiteSelectModal,
        parent: this,
        props: {
          data: {
          },
        },
        events: {
          close(param) {
            vm.form.siteNm1 = param.data.siteNm1          // 사이트명1
            vm.form.siteNm2 = param.data.siteNm2          // 사이트명2
            vm.form.siteNm3 = param.data.siteNm3          // 사이트명3
            vm.form.addr1 = param.data.addr1              // 주소1
            vm.form.addr2 = param.data.addr2              // 주소2
            vm.form.chargeNm = param.data.chargeNm        // 고객명
            vm.form.telNo = param.data.telNo              // 전화번호
            vm.form.hpNo = param.data.hpNo                // 핸드폰
            vm.form.siteId = param.data.siteId            // 사이트Id
            vm.form.siteType = param.data.siteType        // 고객구분
            vm.form.siteTypeNm = param.data.siteTypeNm    // 고객구분
            vm.form.zipCd = param.data.zipCd              // 주소
            vm.getAgentId(param.data.asAgentId)           // 지역/센터, 처리기사 세팅
          },
        }
      });
    },
    changeData(){
      //고객구분 코드 => 코드명 변경
      this.form.siteTypeNm = this.form.siteNm1+this.form.siteNm2+this.form.siteNm3;

      this.form.procUnitPrice1 = comma(this.form.procUnitPrice1);  // 처리비
      this.form.procUnitPrice2 = comma(this.form.procUnitPrice2);  // 단가
      this.form.procEtcPrice1 = comma(this.form.procEtcPrice1);    // 출장급지
      this.form.procEtcPrice2 = comma(this.form.procEtcPrice2);    // 기타비용

      this.form.squareProcUnitPrice1 = comma(this.form.squareProcUnitPrice1) // 처리비
      this.form.squareProcEtcPrice1 = comma(this.form.squareProcEtcPrice1)   // 원거리수당
      this.form.squareProcEtcPrice2 = comma(this.form.squareProcEtcPrice2)   // 기타비용
    },
    updateRealItem(){
      const that = this;

      // const rowNode = this.mainGridApi.getRowNode(this.mainRowId);
      const rowNode = this.mainGridApi.getRowNode(this.mainRowIndex);

      console.log('rowNode    ', rowNode);

      console.log('this.mainGridApi     ', this.mainGridApi);

      this.$modal.open({
        component: ReqMateEnterModal,
        parent: this,
        width: 700,
        props: {
          data: {
            modelNm : that.form.modelNm
          }
        },
        events: {
          close(object) {
            console.log('object     ', object);

            rowNode.setDataValue('recallItemCd', object.itemCd);
            rowNode.setDataValue('recallItemNm', object.itemNm);
            that.mainData[that.mainRowIndex].recallItemCd = object.itemCd;
            that.mainData[that.mainRowIndex].recallItemNm = object.itemNm;
          }
        }
      });
    },
    onCellValueChanged(params) {

      if (params.colDef.field === "applyItemGoodQty") {
        // a 컬럼이 변경되었을 때만 처리
        const newValue = params.newValue;
        const rowIndex = params.rowIndex;
        const newData = this.mainData[rowIndex];
        newData.recallItemQty = newValue       // 회수수량의 값을 사용수량 값으로 변경
        this.$set(this.mainData, rowIndex, newData);    // 변경된 데이터를 반영
      }
    },
    buttonClickEventAction(param){
      let vReturnMsg;

      if(!this.validation(param)) return false;

      let vform = {
        companyId: this.$store.state.loginInfo.compCd,
        requestId: this.form.requestId,
        squareProcUnitPrice1 : this.removeCommas(this.form.squareProcUnitPrice1),
        squareProcEtcPrice1 : this.removeCommas(this.form.squareProcEtcPrice1),
        squareProcEtcPrice2 : this.removeCommas(this.form.squareProcEtcPrice2),
        division : param,
      }

      if(param === 'APPROVAL' || param === 'APPROVALCANCEL' ){
        vform.confirmYn = param === 'APPROVAL' ? 'Y' : 'N'
      } else if (param === 'SQUARE' || param === 'SQUARECANCEL'){
        vform.squareYn = param === 'SQUARE' ? 'Y' : 'N'
        vform.squareYymm = this.form.squareYymm
      }

      if(['APPROVAL', 'SQUARE'].includes(param)){
        vReturnMsg = '완료되었습니다.'
      } else if (['APPROVALCANCEL', 'SQUARECANCEL'].includes(param)){
        vReturnMsg = '취소되었습니다.'
      }

      this.$store.commit('loading')
      this.$http.post("/api/workMng/approval/procBsMa", vform).then(response => {
        this.$swal({ type: 'success', text: vReturnMsg });
      }).finally(() => {
        this.$store.commit('finish')
        this.$parent.close();
        this.$parent.$parent.goOpen();

      });
    },
    validation(param) {
      // "MODIFY" 진행중
      // "SUCCESS" 설치완료
      if(["MODIFY", "SUCCESS"].includes(param)) {
        if(this.form.procYn === 'Y'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.confirmYn === 'Y'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
        if(param === "SUCCESS") {
          // if(this.form.squareYn === 'Y'){
          //   this.$swal({ type: 'warning', text: '설치완료 하시려면 설치모델의 제조번호를 반드시 입력하셔야 합니다.' });
          // }
        }
      } else if(param === "APPROVAL"){
        // 승인
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'Y'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
      } else if(param === "APPROVALCANCEL"){
        // 승인취소
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'N'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
      } else if(param === "SQUARE"){
        // 정산
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'N'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.squareYymm.length < 5){
          this.$swal({ type: 'warning', text: '정산년월을 선택해주세요.' });
          return false;
        }
      } else if(param === "SQUARECANCEL") {
        // 정산취소
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'N'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.squareYn === 'N'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건이 아닙니다.' });
          return false;
        }
      }
      return true;
    },
    // 콤마를 제거하는 함수
    removeCommas(numberString) {
      return String(numberString).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    },
    calculatedResult(inputValue1, inputValue2, inputValue3) {
      const number1 = parseInt(this.removeCommas(inputValue1));
      const number2 = parseInt(this.removeCommas(inputValue2));
      const number3 = parseInt(this.removeCommas(inputValue3));

      if (number1 !== null && number2 !== null && number3 !== null) {
        return number1 + number2 + number3;
      } else {
        return null;
      }
    },
    squareProcCalcAmt(param){
      if(param === ''){
        if(this.form.squareProcEtcPrice1 === '') this.form.squareProcEtcPrice1 = 0;
        if(this.form.squareProcEtcPrice2 === '') this.form.squareProcEtcPrice2 = 0;
      }
      this.form.squareProcAmt = this.calculatedResult(this.form.squareProcUnitPrice1, this.form.squareProcEtcPrice1, this.form.squareProcEtcPrice2);
    },
    isAuth(){
      this.auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===176); // 설치내역 팝업
      const auth = this.auth

      //todo 임시 주석처리 권한 처리 확인 필요 시작
      if(auth && auth.length > 0){
      //   this.showBtnModify = auth[0].grantUpdate === 'Y' ? true : false;           // 진행중
      //   this.showBtnSuccess = auth[0].grantExtend2 === 'Y' ? true : false;         // 설치완료
         this.showBtnApproval = auth[0].grantExtend3 === 'Y' ? true : false;        // 승인
         this.showBtnApprovalCancel = auth[0].grantExtend4 === 'Y' ? true : false;  // 승인취소
         this.showBtnSquareCancel = auth[0].grantExtend6 === 'Y' ? true : false;    // 정산취소
         this.showBtnSquare = auth[0].grantExtend5 === 'Y' ? true : false;          // 정산
         this.disabledSquareYymm = auth[0].grantExtend5 === 'Y' ? false : true;     // 정산년월
         this.disabledSquareProcUnitPrice1 = (auth[0].grantExtend3 === 'Y' && auth[0].grantExtend5 === 'Y' ) ? true : false;   //정산비용 처리비
         this.disabledSquareProcEtcPrice1 = (auth[0].grantExtend3 === 'Y' && auth[0].grantExtend5 === 'Y' ) ? true : false;    //정산비용 원거리출장비
         this.disabledSquareProcEtcPrice2 = (auth[0].grantExtend3 === 'Y' && auth[0].grantExtend5 === 'Y' ) ? true : false;    //정산비용 기타비용
         this.disabledSquareProcAmt = (auth[0].grantExtend3 === 'Y' && auth[0].grantExtend5 === 'Y' ) ? true : false;          //정산비용 합계
      }
      //todo 임시 주석처리 권한 처리 확인 필요 종료
    },
    procChk(){
     if(this.form.procYn !== 'Y'){

       this.form.squareProcUnitPrice1 = '';
       this.form.squareProcEtcPrice1 = '';
       this.form.squareProcEtcPrice2 = '';
       this.form.squareProcAmt = '';
       this.form.squareYymm = '';
     }
    }
  },
  mounted() {

    this.getCombo()
    //pop slots modal move
    $(".animation-content").addClass('pop_min2');
    $(".animation-content").draggable({'cancel':'.modal-card-body'});
    //ModalSlot open z-index change
    $('.lnb').css('z-index', '4');

    this.setBsMaEditInfo();
    this.procChk();
    // this.goOpen('INIT', 0)

  },
  watch: {
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>



